import { render } from "./EventDetail.vue?vue&type=template&id=383699ba&scoped=true"
import script from "./EventDetail.vue?vue&type=script&lang=js"
export * from "./EventDetail.vue?vue&type=script&lang=js"

import "./EventDetail.vue?vue&type=style&index=0&id=383699ba&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-383699ba"

export default script